
import styled from 'styled-components/macro'

const Root = styled.button`
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 11px 15px;
  border: 1px solid rgba(171, 154, 144, 0.5);
  cursor: pointer;
  color: rgba(0, 0, 0, 0.9);
  font-family: 'Montserrat';
  background-color: ${(props) => props.active ? 'rgba(213, 200, 200, 0.6)' : '#FFFFFF'};
  text-transform: capitalize;

  :disabled {
    color: rgba(16, 16, 16, 0.3);
    cursor: not-allowed;
  }

  @media (max-width: 1200px) {
    font-size: 10px;
  }
`


const Button = ({type = 'button', children, onClick, active, disabled}) => {

  return (
      <Root type={type} onClick={onClick} active={active} disabled={disabled}>
        {children}
      </Root>
  )
}

export default Button